import React, {useEffect, useState} from "react";
import {Input} from "../ui/input";
import {Textarea} from "../ui/textarea";
import {Alert} from "../../pages/alerts/model";

export function AlertNameSelector(props: {
    stepNumber: number,
    alert: Alert,
    setAlert: (value: (((prevState: Alert) => Alert) | Alert)) => void
}) {
    const [localName, setLocalName] = useState(props.alert.name);
    const [localDescription, setLocalDescription] = useState(props.alert.description);

    useEffect(() => {
        setLocalName(props.alert.name);
        setLocalDescription(props.alert.description);
    }, [props.alert.name, props.alert.description]);

    return <div className={"flex flex-col gap-4"}>
        <div className={"flex justify-start gap-2"}>
            <div
                className={"h-[36px] w-[36px] border border-primary bg-primarytransparent text-textlight flex flex-col justify-center text-center font-semibold rounded"}>
                {props.stepNumber}
            </div>
            <div className={"text-lg flex flex-col justify-center text-center text-textlight"}>
                Name alert
            </div>
        </div>
        <div className={"flex justify-start text-textmedium"}>
            <div className={"flex gap-2 grow"}>
                <Input
                    value={localName}
                    onChange={(e) => setLocalName(e.target.value)}
                    onBlur={() => {
                        props.setAlert((prev) => ({...prev, name: localName}));
                    }}
                    className={"h-[32px] flex justify-center border-border items-center text-textmedium border gap-2 p-2 rounded bg-none hover:text-textlight hover:border-primary cursor-pointer px-4"}
                    placeholder={"Alert Name"}
                />
            </div>
        </div>
        <div className={"flex justify-start"}>
            <div className={"flex gap-2 grow"}>
                <Textarea
                    value={localDescription}
                    onChange={(e) => setLocalDescription(e.target.value)}
                    onBlur={() => {
                        props.setAlert((prev) => ({...prev, description: localDescription}));
                    }}
                    className={"h-[32px] flex justify-center items-center text-textmedium border gap-2 p-2 rounded bg-none border-border hover:text-textlight hover:border cursor-pointer px-4"}
                    placeholder={"Alert Description"}
                />
            </div>
        </div>
    </div>
}